<div class="auth-wrapper">
  <div class="form-container">
    <h1>Check your email</h1>
    <p>{{ message }}</p>

    <div class="muted">
      <p>If you can’t tap the button in the email, you can verify here:</p>
    </div>

    <button class="btn-primary" routerLink="/authentication">
      Verify email
    </button>

    <p class="muted">Also check your spam/junk folder.</p>

    <div class="links">
      <a routerLink="/login">Go to login</a>
      <span> | </span>
      <a routerLink="/register">Use a different email</a>
    </div>
  </div>
</div>
